import AccountActivation from "./AccountActivation.vue";
export default AccountActivation;
